import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { MarginExpenseType } from '../models/margin-expense-type.model';

@Injectable({ providedIn: 'root' })
export class MarginExpensesService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getMarginExpensesTypes(): Observable<MarginExpenseType[]> {
        const url = combine(this.coreApiPath, 'locums/margins/expenses/types');
        return this.http.get<MarginExpenseType[]>(url);
    }
}
